// src/components/CampaignIntelModules.jsx
import { Stack, Heading } from "@chakra-ui/react";
import Card from "./Card";
import CampaignSuggestions from "./CampaignSuggestions";
import SectorROIInsights from "./SectorROIInsights";
import CampaignIntelligenceSummary from "./CampaignIntelligenceSummary";
import MyCampaigns from "./MyCampaigns";

/**
 * CampaignIntelModules
 *
 * Props:
 *  - authId (uuid, businesses.auth_id)   🔥 REQUIRED for intel RPCs
 *  - flyerId (uuid, flyers.id)
 *  - groupId (uuid/string, groups.id)
 */
export default function CampaignIntelModules({ authId, flyerId, groupId }) {
  return (
    <Stack spacing={6} mt={8}>

      {/* My Campaign Slots */}
      <Card>
        <Heading as="h2" size="sm" mb={2}>
          📦 My Campaign Slots
        </Heading>
        <MyCampaigns
          businessId={authId}     // 🔥 now correct
          flyerId={flyerId}
          groupId={groupId}
        />
      </Card>

      {/* AI Suggestions */}
      <Card>
        <Heading as="h2" size="sm" mb={2}>
          🧠 AI Campaign Suggestions
        </Heading>
        <CampaignSuggestions
          businessId={authId}     // 🔥 now correct
          flyerId={flyerId}
          groupId={groupId}
        />
      </Card>

      {/* Sector ROI Insights */}
      <Card>
        <Heading as="h2" size="sm" mb={2}>
          📈 Sector ROI Insights
        </Heading>
        <SectorROIInsights
          businessId={authId}     // 🔥 now correct
          flyerId={flyerId}
          groupId={groupId}
        />
      </Card>

      {/* Intelligence Summary */}
      <Card>
        <Heading as="h2" size="sm" mb={2}>
          📊 Campaign Intelligence Summary
        </Heading>
        <CampaignIntelligenceSummary
          businessId={authId}     // 🔥 now correct
          flyerId={flyerId}
          groupId={groupId}
        />
      </Card>

    </Stack>
  );
}
